module.exports = __webpack_public_path__ + "static/garneau-f3867378f6ec07127f30366b8b165508.jpg";